import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

import * as routes from '../settings/_routesSettings';

import HeaderMenu from '../containers/HeaderMenu/';

const PaymentPrivateRoute = ({ isAuth, component: Component, ...rest }) => (
  <Route {...rest} component={(props) => (
    isAuth ? (
      <div style={{ backgroundColor: '#f5f5f5' }}>
        <HeaderMenu isSuccinct/>
        <Component {...props} />
      </div>
    ) : (
      <Redirect to={routes.HOME_PSIC} />
    )
  )}
  />
);

const mapStateToProps = (state) => ({ isAuth: state.auth.isAuth });

export default connect(mapStateToProps)(PaymentPrivateRoute);